import {isEmpty} from "@/lib/util";

export const docPrivateServePrice = (obj) => {
  if (typeof obj !== 'object' || isEmpty(obj)) return;
  let {servePrice, serveLengthOfTimeUnit, serveLengthOfTime} = obj;
  return `${servePrice / 100}元/${serveLengthOfTime}${serveLengthOfTimeUnit}`;
}

export const docTitleMixin = {
  data() {
    return {
      docTitleFields: ['docTitle', 'teachTitleName']
    }
  },
  methods: {
    renderDocTitleHtml(data) {
      let html = '';
      this.docTitleFields.forEach(title => {
        if (data[title]) {
          html += ` <font style="font-size: 12px;color: #d9d9d9">|</font> ${data[title]}`;
        }
      })
      return html;
    }
  },
}



// WEBPACK FOOTER //
// ./src/page/doc/lib.js